<div *ngFor="let account of accounts" class="bg-ffefef rounded-lg p-3">
  <p class="uppercase text-black font-semibold text-base mb-3 px-3">
    {{ account?.acc_name || 'Account' }}
  </p>

  <div class="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-6 lg:grid-cols-10 gap-2">

    <!-- Image -->
    <div class="hidden col-span-1 lg:border-r border-gray-300 lg:flex items-center md:justify-center">
      <div class="w-16 h-16 lg:w-20 lg:h-20 xl:w-25 xl:h-25">
        <img class="w-full h-full rounded-full" src="/assets/images/user/account-user.png" alt="account-user">
      </div>
    </div>

    <!-- Column 1 -->
    <div class="col-span-1 md:col-span-2 lg:col-span-3">
      <div class="text-xs lg:text-[13px] xl:text-sm 2xl:text-base font-medium space-y-2 px-1.5 xl:px-3 py-2">

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-24 lg:min-w-34 xl:min-w-40">Account Name</span>:
          <span class="text-383838">{{ account?.acc_name }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-24 lg:min-w-34 xl:min-w-40">Account Description</span>:
          <span class="text-383838">{{ account?.acc_description }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-24 lg:min-w-34 xl:min-w-40">Account Type</span>:
          <span class="text-383838">{{ account?.acc_main_acc }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-24 lg:min-w-34 xl:min-w-40">Opening Balance Date</span>:
          <span class="text-383838">{{ account?.acc_cash_balance_date }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-24 lg:min-w-34 xl:min-w-40">Cash Balance</span>:
          <span class="text-383838">₹ {{ account?.acc_cash_balance }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-24 lg:min-w-34 xl:min-w-40">Sales Tax No</span>:
          <span class="text-383838">{{ account?.acc_sales_tax_no }}</span>
        </p>

      </div>
    </div>

    <!-- Column 2 -->
    <div class="col-span-1 md:col-span-2 lg:col-span-3">
      <div class="text-xs lg:text-[13px] xl:text-sm 2xl:text-base font-medium space-y-2 px-1.5 xl:px-3 py-2">

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-14 lg:min-w-16 xl:min-w-20">Address</span>:
          <span class="text-383838">{{ account?.acc_address }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-14 lg:min-w-16 xl:min-w-20">State</span>:
          <span class="text-383838">{{ account?.state?.name }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-14 lg:min-w-16 xl:min-w-20">Country</span>:
          <span class="text-383838">{{ account?.country?.name }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-14 lg:min-w-16 xl:min-w-20">City</span>:
          <span class="text-383838">{{ account?.city?.name }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-14 lg:min-w-16 xl:min-w-20">Pincode</span>:
          <span class="text-383838">{{ account?.acc_pincode }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-14 lg:min-w-16 xl:min-w-20">PAN/IT No</span>:
          <span class="text-383838">{{ account?.acc_pan_it_no }}</span>
        </p>

      </div>
    </div>

    <!-- Column 3 -->
    <div class="col-span-1 md:col-span-2 lg:col-span-3">
      <div class="text-xs lg:text-[13px] xl:text-sm 2xl:text-base font-medium space-y-2 px-1.5 xl:px-3 py-2">

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-18.5 lg:min-w-21 xl:min-w-28">Bank A/C No.</span>:
          <span class="text-383838">{{ account?.acc_banc_acc_no }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-18.5 lg:min-w-21 xl:min-w-28">Branch Name</span>:
          <span class="text-383838">{{ account?.acc_branch_name }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-18.5 lg:min-w-21 xl:min-w-28">BSR Code</span>:
          <span class="text-383838">{{ account?.acc_bsr_code }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-18.5 lg:min-w-21 xl:min-w-28">IFSC Code</span>:
          <span class="text-383838">{{ account?.acc_ifs_code }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-18.5 lg:min-w-21 xl:min-w-28">CST No.</span>:
          <span class="text-383838">{{ account?.acc_cst_no }}</span>
        </p>

        <p class="capitalize flex items-start justify-start gap-2 text-888383">
          <span class="block min-w-18.5 lg:min-w-21 xl:min-w-28">Other Info</span>:
          <span class="text-383838">{{ account?.acc_other_info }}</span>
        </p>

      </div>
    </div>

  </div>
</div>